export default {
  tags: {
    default: 'Domyślna',
    visible_to: 'Widoczna dla',
    not_visible_to: 'Niewidoczna dla',
  },
  labels: {
    inclusive: 'Brutto',
    exclusive: 'Netto',
    public: 'Publiczna',
  },
  buttons: {
    edit: 'Edytuj',
    delete: 'Usuń',
  },
};
